import React from 'react'
import PropTypes from 'prop-types';
import GridBlock from "components/GridBlock";
import {Badge, makeStyles, Typography} from "@material-ui/core";
import Tr from "translations/Translations";
import clsx from 'clsx';
import BoldTypography from "components/BoldTypography";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import MailIcon from "@material-ui/icons/Mail";
import {getUserFullNameWithDeputy} from "../../../../../../../../libs/userNameGetter";

const useStyles = makeStyles(theme => ({
    root: {
        width: '80%',
        margin: 5,
    },
    rootMine: {
        marginLeft: '20%'
    },
    contentWrapper: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        position: 'relative'
    },
    contentWrapperUnread: {
        borderWidth: 3
    },
    contentWrapperMine: {
        backgroundColor: theme.palette.background.default
    },
    content: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    },
    sendDate: {
        margin: `0 ${theme.spacing(1)}px`,
        minWidth: 110
    },
    message: {
        whiteSpace: 'pre-line',
        margin: `${theme.spacing(2)}px 0`
    },
    newBadge: {
        position: 'absolute',
        right: 0,
        top: 3
    },
}));


function OpinionMessage(
    {
        coordinatorView,
        message
    }) {

    const classes = useStyles();
    const mine = !!(coordinatorView ? message.memberMessage : !message.memberMessage);
    const unread = !mine && !message.read;

    return (
        <div className={clsx(classes.root, {[classes.rootMine]: mine, 'new-message-scroll-to': unread})}>

            <div className={clsx(classes.contentWrapper, {[classes.contentWrapperMine]: mine, [classes.contentWrapperUnread]: unread})}>
                <div className={classes.content}>
                    {unread && <Badge className={clsx(classes.newBadge)} badgeContent='NOWA' color="error">
                        <MailIcon color='primary'/>
                    </Badge>}
                    <GridBlock justify="space-between">
                        <GridBlock>
                            <BoldTypography variant='caption'>{Tr("author")}</BoldTypography>
                            <Typography variant='caption' component='p' className={classes.sendDate}>
                                {getUserFullNameWithDeputy(message.author)}
                            </Typography>
                        </GridBlock>
                        <GridBlock>
                            <BoldTypography variant='caption'>{Tr("send_date")}</BoldTypography>
                            <Typography variant='caption' component='p' className={classes.sendDate}>
                                {message.sendDate ? moment(message.sendDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT) : ''}
                            </Typography>
                        </GridBlock>
                    </GridBlock>

                    <Typography variant='body1' className={classes.message}>{message.contents}</Typography>

                </div>
            </div>
        </div>
    )
}

OpinionMessage.propTypes = {
    classes: PropTypes.any,
}

export default OpinionMessage;